export const cplQuizURL = 'cpl-course-quizzes/quiz';
export const cplQuizRequestURL = 'cpl-course-quizzes/quiz-request'
export const cplDraftQuizURL = 'cpl-course-quizzes/quiz/draft';
export const cplDraftQuizQuestionURL = (question_id: string) => `cpl-course-quizzes/quiz/draft/question/${question_id}`;
export const cplDraftQuizByIDURL = (id: string) => `cpl-course-quizzes/quiz/draft/${id}`;
export const cplDraftQuizOutcomesByIDURL = (id: string) => `/cpl-course-quizzes/quiz/${id}/learning-outcomes`;
export const assignQuizURL = 'cpl-course-quizzes/quiz-request';
export const cplQuizResultsURL = 'cpl-course-quizzes/quiz/complete';
export const cplQuizResultsEditURL = (id: string) => `/cpl-course-quizzes/cpl-course-quizzes/quiz/question/response/annotation/${id}`;